import { render } from "./HeroFormHeader.vue?vue&type=template&id=1253ed53&scoped=true"
import script from "./HeroFormHeader.vue?vue&type=script&lang=js"
export * from "./HeroFormHeader.vue?vue&type=script&lang=js"

import "./HeroFormHeader.vue?vue&type=style&index=0&id=1253ed53&scoped=true&lang=css"

import exportComponent from "/Users/alvinvergara/Developer/Lead Dev - Projects/DAP/iwc_dap/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1253ed53"]])

export default __exports__